import React, { useEffect, useRef, useState } from 'react';
import './index.less';

const SwiperComponent = ({ 
    images = []
}) => {
    const swiperRef = useRef(null);
    const swiperInstance = useRef(null);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        // 通过 HTML 已引入本地 Swiper 资源，直接就绪
        setIsReady(true);
    }, []);

    useEffect(() => {
        if (isReady && window.Swiper && swiperRef.current && images.length > 0) {
            // 销毁之前的实例
            if (swiperInstance.current) {
                swiperInstance.current.destroy(true, true);
            }

            // 创建新的Swiper实例
            swiperInstance.current = new window.Swiper(swiperRef.current, {
                   loop: images.length > 2, // 只有3张及以上图片时才循环
                   autoplay: images.length > 2 ? {
                       delay: 2500,
                       disableOnInteraction: false,
                       pauseOnMouseEnter: true,
                   } : false, // 只有3张及以上图片时才自动播放
                   slidesPerView: 'auto', // 自动计算显示数量
                   effect: "slide", // 使用普通的滑动效果
                   centeredSlides: true, // 居中显示
                   spaceBetween: 20, // 图片之间间距20px
                   pagination: images.length > 2 ? {
                       el: ".swiper-pagination",
                       clickable: true,
                       dynamicBullets: true,
                   } : false, // 2张及以下图片时不显示分页器
                   observer: true,
                   observeParents: true,
                   navigation: images.length > 2 ? {
                       nextEl: ".swiper-button-next",
                       prevEl: ".swiper-button-prev",
                   } : false, // 2张及以下图片时不显示导航按钮
                   // 确保自动播放正常工作
                   watchSlidesProgress: true,
                   watchSlidesVisibility: true,
               });

            // 手动启动自动播放
            if (images.length > 2 && swiperInstance.current.autoplay) {
                swiperInstance.current.autoplay.start();
            }
        }

        // 清理函数
        return () => {
            if (swiperInstance.current) {
                swiperInstance.current.destroy(true, true);
                swiperInstance.current = null;
            }
        };
    }, [isReady, images]);

    // 处理鼠标悬停暂停自动播放
    const handleMouseEnter = () => {
        if (swiperInstance.current && swiperInstance.current.autoplay) {
            swiperInstance.current.autoplay.stop();
        }
    };

    const handleMouseLeave = () => {
        if (swiperInstance.current && swiperInstance.current.autoplay && images.length > 2) {
            swiperInstance.current.autoplay.start();
        }
    };

    return (
        <div className="swiper-father">
            <div className="index-mian">
                <div className="w1200 clearfix por">
                    <div className="swiper-box">
                        <div 
                            className={`swiper-container ${images.length <= 2 ? 'swiper-container-few-slides' : ''}`}
                            ref={swiperRef}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                        >
                            <div className="swiper-wrapper">
                                {images.map((imageSrc, index) => (
                                    <div key={index} className="swiper-slide">
                                        <img src={imageSrc} alt={`轮播图${index + 1}`} style={{width: '340px', height: '255px', objectFit: 'cover', display: 'block'}} />
                                    </div>
                                ))}
                            </div>
                            {images.length > 2 && <div className="swiper-pagination"></div>}
                        </div>
                        {images.length > 2 && (
                            <>
                                <div className="swiper-button-prev"></div>
                                <div className="swiper-button-next"></div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SwiperComponent;